import constants from "../../../../../../../appConstants";
import { MultiSelectFilter, DateTimeFilter } from "../../../../../../dataGrid/columnFilters";
import {SeverityIcon} from "./components";
import { formatMonthDateYearWithoutUTC } from "../../../../../../dataGrid/gridUtilities";

export default class GridConfig {
  constructor(configuration, title) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config, title);
  }
  static getConfiguration(userConfig, title) {
    return GridConfig.getDefaultConfiguration(title, userConfig);
  }

  static renderSeverityIcon = (props) => {
    if (!props.value) {
      return null;
    }
    return <SeverityIcon severity={props.value} />;
  };

  static getDefaultConfiguration(title, userConfig) {
    return {
      title: title,
      keyColumn: "",
      rowSelection: "multiple",
      rowDeselection: true,
      suppressRowTransform: true,
      defaultColDef: {
        lockPinned: true,
        sortable: true,
        filter: true,
        resizable: true,
        editable: false,
        lockPosition: true,
      },
      columns: [
        {
          headerName: "Equip #",
          field: "equipNumber",
          width: constants.columnWidth.EQUIPMENT,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
        },
        {
          headerName: "Category",
          field: "defectCategory",
          width: constants.columnWidth.CATEGORY,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          tooltipField:"defectCategory"
        },
        {
          headerName: "Sub Category",
          field: "defectSubCategory2",
          width: constants.columnWidth.SUB_CATEGORY,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          tooltipField:"defectSubCategory2"
        },
        {
          headerName: "Defect",
          field: "comments",
          width: constants.columnWidth.DEFECT,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          tooltipField:"comments"
        },
        {
          headerName: "Severity",
          field: "severity",
          width: constants.columnWidth.SEVERITY,
          cellClass: "gridCell-leftAlign",
          cellRendererFramework: GridConfig.renderSeverityIcon,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Date",
          field: "addedDate",
          width: constants.columnWidth.DEFECT_DATE,
          cellClass: "gridCell-leftAlign",
          valueFormatter: (params) => formatMonthDateYearWithoutUTC(params),
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.MONTHDATEYEAR,
          },
        },
      ],
    };
  }
}
